import { AxisSwitcher, GridBox, H1, Image } from '@ahmdigital/ui';
import React from 'react';

import { mobileThreshold } from '../../constants';
import styles from './styles.module.sass';

type HeaderDescriptionBlockProps = {
  description: React.ReactNode;
  image: {
    alt?: string;
    src?: React.ReactNode;
  };
  title: string;
};

const HeaderDescriptionBlock = ({ description, image: { alt, src }, title }: HeaderDescriptionBlockProps) => (
  <AxisSwitcher reverseColumnPresentationOrder limit={2} space="0" threshold={mobileThreshold}>
    <GridBox padding="0">
      <div className={styles.headerImageWrapper}>
        {/* @ts-expect-error [🤖 PLEASE FIX 🤖]: Type 'ReactNode' is not assignable to type 'string | undefined'. */}
        <Image className={styles.headerImage} alt={alt} src={src} />
      </div>
    </GridBox>

    <GridBox minWidth="70%" padding="0">
      <H1>{title}</H1>
      {description}
    </GridBox>
  </AxisSwitcher>
);

export default HeaderDescriptionBlock;
